const UNKNOWN = "UNKNOWN"

export class BaseCRUD {

  get() {
    this._WARNING("get")
  }

  create() {
    this._WARNING("create")
  }

  update() {
    this._WARNING("update")
  }

  delete() {
    this._WARNING("delete")
  }

  list() {
    this._WARNING("list")
  }

  _WARNING(fnName = UNKNOWN) {
    console.warn("WARNING! Function \"" + fnName + "\" is not overridden in " + this.constructor.name)
  }
}
